import { MenuFoldOutlined, MenuUnfoldOutlined, UploadOutlined, UserOutlined, VideoCameraOutlined, } from '@ant-design/icons';
import { Layout, Menu, Row, Col, Button, Space } from 'antd';
import { Avatar } from 'antd';
import type { MenuProps } from 'antd';
import React, { useEffect, useState } from 'react';
import { PngImage } from '../components/_common/PngImage';
import { CustomContentSection, CustomHeader, CustomLayout, UserAvatorContainer, TriggerContainer, WelcomeTitle, UserAvatorTitle, UserAvatorRule, Right, CompanyLogoContainer } from './styles';
import { Link, Outlet, useNavigate } from "react-router-dom";
import DrawerMenu from './Menu';
import { multiLevelFilter } from '../utility/utilities';
import { useAppDispatch, useAppSelector } from '../redux/store/storehooks';
import Container from '../components/_common/Container';
import { Footer } from 'antd/lib/layout/layout';
import { logout } from '../redux/reducers/authSlice';
import CustomFooter from '../components/footer/CustomFooter';
import EditFinancialInfo from '../pages/financial/EditFinancialInfo';

const { Header, Sider, Content } = Layout;

const DashboardLayout: React.FC = () => {
    const [openKeys, setOpenKeys] = useState(['sub1']);
    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate()
    const drawerMenu = DrawerMenu();
    const store = useAppSelector((state) => state)
    const dispatch = useAppDispatch();

    const menuOnClick: MenuProps['onClick'] = e => {
        
        let menu = multiLevelFilter(drawerMenu, e.key);

        if (menu != null) {
            if (menu[0].type === 'group') {
                menu = multiLevelFilter(menu[0].children, e.key);
            }
            else {
                menu = multiLevelFilter(menu[0].children, e.key);
            }
        }

        if (menu != null) {
            if (menu[0].path !== "") navigate(menu[0].path)
        }

    };
    useEffect(() => {

        if (window.matchMedia('(max-width: 1023px)').matches) {
            setCollapsed(true)
        }
    }, [])
    const signOut = () => {
        dispatch(logout());
    }
    const rootSubmenuKeys = ['sub1', 'sub2', 'sub4'];
    const onOpenChange: MenuProps['onOpenChange'] = (keys) => {
        const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
        if (rootSubmenuKeys.indexOf(latestOpenKey!) === -1) {
            setOpenKeys(keys);
        } else {
            setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
    };
    return (
        <Layout >
            <Sider trigger={null} collapsible collapsed={collapsed} style={{ height: '100vh', width: '225px' }}>

                <UserAvatorContainer>
                    <Row>
                        <Col lg={24} md={24} sm={24} xs={24}>
                            <Avatar size="large" icon={<UserOutlined />} />
                        </Col>
                        <Col lg={24} md={24} sm={24} xs={24}>
                            <UserAvatorTitle>{store.auth.userTitle}</UserAvatorTitle>
                        </Col>
                        {/* <Col lg={24} md={24} sm={24} xs={24}>
                            <UserAvatorRule>{auth.loginType}</UserAvatorRule>
                        </Col> */}
                          {store.auth.loginType === 'labuser' &&
                         ( <Col lg={24} md={24} sm={24} xs={24}>
                            <Link style={{color:'yellow'}} to="/labuser/editfinancialinfo"> ویرایش اطلاعات </Link>
                        </Col>
                            )}
                        <Col lg={24} md={24} sm={24} xs={24}>
                            <Button type="primary" style={{ backgroundColor: "red" }} onClick={signOut}>{"خروج"}</Button>
                        </Col>
                    </Row>
                </UserAvatorContainer>

                <Menu
                    openKeys={openKeys}
                    theme="dark"
                    onOpenChange={onOpenChange}
                    mode="inline"
                    defaultSelectedKeys={['1']}
                    items={drawerMenu}
                    onClick={menuOnClick}
                />

            </Sider>


            <CustomLayout>
                <CustomHeader>
                    <Row>
                        <Col lg={2} md={8} sm={12} xs={12}>
                            <TriggerContainer onClick={() => setCollapsed(!collapsed)}>
                                {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                            </TriggerContainer>
                        </Col>
                        <Col lg={21} md={16} sm={12} xs={12}>
                            <WelcomeTitle >
                                <PngImage src="logo.png" width="36px" height="36px" />
                                <Space style={{ paddingRight: '10px' }} className="fs-14 welcom-header"  >
                                    به سامانه
                                    <span className='co-blue-1'>
                                        پارسی پل
                                    </span>

                                    خوش آمدید
                                </Space>


                            </WelcomeTitle>
                        </Col>

                    </Row>
                </CustomHeader>
                <CustomContentSection>
                    <Container padding={"10px"}>
                        <Outlet />
                        <CustomFooter />
                    </Container>
                </CustomContentSection>
                {/* <CustomFooter/> */}
            </CustomLayout>
        </Layout>
    );
};

export default DashboardLayout;
